// Added by Sejune Oh on 2019-04-11
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { RefObject, FC } from 'react'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core'
import classNames from 'classnames'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime Element
import { Button } from '@/components/_primes'

// Components
import Search from '../../Search'
import { TableFunctionalComponentProps } from '../../Table'
import { MgmtListTemplateBaseCProps } from './MgmtListTemplateContainer'

// Styles
import MgmtListStyle from '@/styles/management/MgmtListStyle'

// Intl
import Intl from '@/helper/Intl'
import { routerPath } from '@/helper/define'
import { SettingTemplate } from '..'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface MgmtListTemplateFCProps
  extends WithStyles<typeof styles>,
    MgmtListTemplateBaseCProps,
    TableFunctionalComponentProps {
  searchRef?: RefObject<Search>
  hideSearch?: boolean
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const MgmtListTemplate: FC<MgmtListTemplateFCProps> = ({ classes, hideSearch = false, ...props }) => {
  const mgmtText = Intl.getIntlText({ id: 'htmljs_react.mgmt.mgmtlisttemplate.bread_crumb_text' })
  const mgmtPath = `/${routerPath.MGMT}`

  return (
    <SettingTemplate
      pageDepth={[[mgmtText, mgmtPath], props.curPathSet!]}
      onSearch={props.onSearch}
      searchRef={props.searchRef}
      defaultValue={props.defaultSearchKeyword}
      hideSearch={hideSearch}
    >
      <div className={classes.MgmtListWrapper}>{props.tableComponent}</div>
      <div className={classNames(classes.ListBtnWrapper)}>
        {props.customButtonComponents || (
          <Button
            buttonType={'task'}
            onClick={props.onAddBtnClick}
            btnText={Intl.getIntlText({ id: 'htmljs_react.mgmt.mgmtlisttemplate.btn_add' })}
            data-cy-btn="moveToAdd"
            data-testid="moveToAdd"
          />
        )}
        {props.hasAdditionalButton && (
          <Button
            buttonType={'default'}
            onClick={props.onAdditionalButtonClick}
            btnText={props.additionalBtnText!}
          />
        )}
      </div>
    </SettingTemplate>
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
  createStyles({
    ...MgmtListStyle(theme),
  })

export default withStyles(styles, { withTheme: true })(MgmtListTemplate)
